import { render, staticRenderFns } from "./StarteBestellungButton.vue?vue&type=template&id=4bad3b61&scoped=true"
import script from "./StarteBestellungButton.vue?vue&type=script&lang=js"
export * from "./StarteBestellungButton.vue?vue&type=script&lang=js"
import style0 from "./StarteBestellungButton.vue?vue&type=style&index=0&id=4bad3b61&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad3b61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bad3b61')) {
      api.createRecord('4bad3b61', component.options)
    } else {
      api.reload('4bad3b61', component.options)
    }
    module.hot.accept("./StarteBestellungButton.vue?vue&type=template&id=4bad3b61&scoped=true", function () {
      api.rerender('4bad3b61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/StarteBestellungButton.vue"
export default component.exports